export default "__VITE_ASSET__e7ed4093__"